import inputFilled from './input-filled';

document.addEventListener('DOMContentLoaded', () => {

    const btns = document.querySelectorAll('.js-add-btn-telegram');
    btns.forEach((btn, index) => {

        const countLength = btn.getAttribute('data-count');

        btn.addEventListener('click',(e)=>{
           e.preventDefault();
           const count = btn.getAttribute('data-count');
           btn.setAttribute('data-count', count - 1);
           const i = countLength - count;
           const parent = btn.parentNode;
            parent.insertAdjacentHTML('beforebegin', '<div class="form__cols">\n' +
               '                                <div class="form__line">\n' +
               '                                    <input class="form__input" type="text" name="newsletter-btn-name-'+i+'" maxlength="255" required>\n' +
               '                                    <label class="form__label">\n' +
               '                                        Название кнопки\n' +
               '                                    </label>\n' +
               '                                </div>\n' +
               '                                <div class="form__line">\n' +
               '                                    <input class="form__input" type="text" name="newsletter-btn-link-'+i+'" maxlength="255" required>\n' +
               '                                    <label class="form__label">Ссылка</label>\n' +
               '                                </div>\n' +
               '                            </div>');
           if(count == 1){
               parent.remove();
           }

            inputFilled();

        });

    });

});
